import React from "react";
import { Avatar, Box, Button, Typography } from "@mui/material";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";

import { Session } from "utils";

import ProfilePictureDialog from "./ProfilePictureDialog";

/**
 * Avatar + "Upload image" — the mobile port of `components/Profile/
 * ProfilePicture`. Desktop puts the 150px avatar to the left of the details
 * form; on a phone it sits centred above it.
 */
export default function ProfilePicture() {
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = React.useState();

  const user = Session.getUser() || {};
  const initial = (user?.name || "").trim().charAt(0).toUpperCase();

  React.useEffect(() => {
    setImage(Session.getUser()?.profileUrl);
  }, []);

  const handleClose = (profileUrl) => {
    if (typeof profileUrl === "string") setImage(profileUrl);
    setOpen(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 3,
      }}
    >
      <Box sx={{ position: "relative" }} onClick={() => setOpen(true)}>
        <Avatar
          src={image}
          sx={{
            width: 96,
            height: 96,
            bgcolor: "neutral.clr-200",
            border: "1px solid",
            borderColor: "neutral.clr-100",
          }}
        >
          <Typography variant="h4-medium" color="neutral.clr-600">
            {initial}
          </Typography>
        </Avatar>

        <Box
          sx={{
            position: "absolute",
            right: -2,
            bottom: -2,
            width: 32,
            height: 32,
            borderRadius: "50%",
            bgcolor: "primary.clr-300",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid",
            borderColor: "shades.clr-white-900",
          }}
        >
          <PhotoCameraOutlinedIcon
            sx={{ fontSize: 16, color: "shades.clr-white-900" }}
          />
        </Box>
      </Box>

      <Button variant="outlined" size="small" onClick={() => setOpen(true)}>
        Upload Image
      </Button>

      <ProfilePictureDialog open={open} onClose={handleClose} />
    </Box>
  );
}
